import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import HospitalityCategoryPackage from './Category';
import type { HospitalityOptions } from './types';

import { getEditorialsQuery } from '@queries/editorial';
import { language } from '@utilities/browser';
import { competitionId, currentSeason } from '@utilities/WindowContext';

const HospitalityCategoryPage = ({ options }: { options: HospitalityOptions }) => {
  const ticketFilters = useMemo(
    () => ({
      type: 'ticket',
      'param.attributes.competitions': competitionId,
      'param.attributes.language': language,
      'param.attributes.main.season': currentSeason,
      'param.attributes.main.kind': options.kind,
      'param.attributes.sections': options.section,
      'param.attributes.hashtags': options.hashtag,
      'param.attributes.footballEntities.venue.venueId': options.venueId,
      'param.attributes.footballEntities.match.matchId': options.matchId,
      aggregator: 'lightnodejson',
    }),
    [options],
  );

  const { data } = useQuery({
    ...getEditorialsQuery(ticketFilters),
    select: (data) => data?.[0],
  });
  if (!data) return null;
  return <HospitalityCategoryPackage articleId={data?.id} />;
};

export default HospitalityCategoryPage;
